const FEEDBACK_ENDPOINT = 'https://api.web3forms.com/submit';

class FeedbackModal extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.feedback-trigger');
    this.overlay = this.querySelector('[data-feedback-overlay]');
    this.panel = this.querySelector('.feedback-panel');
    this.form = this.querySelector('[data-feedback-form]');
    this.status = this.querySelector('[data-feedback-status]');
    this.submitButton = this.querySelector('.feedback-form__submit');
    this.title = this.querySelector('.feedback-panel__title');
    this.successView = this.querySelector('[data-feedback-success]');
    const closeButton = this.querySelector('[data-feedback-close]');

    // Snippet always renders these together; guard keeps the element inert if markup drifts.
    if (!this.trigger || !this.overlay || !this.form || !this.status || !this.submitButton || !this.successView || !closeButton) {
      return;
    }

    this.trigger.addEventListener('click', this.open.bind(this));
    closeButton.addEventListener('click', this.close.bind(this));
    this.overlay.addEventListener('click', (event) => {
      if (event.target === this.overlay) this.close();
    });
    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  open() {
    this.resetView();
    this.overlay.hidden = false;
    document.body.classList.add('overflow-hidden');
    this.form.querySelector('.feedback-form__message').focus();
  }

  resetView() {
    this.form.hidden = false;
    if (this.title) this.title.hidden = false;
    this.successView.hidden = true;
  }

  showSuccess() {
    this.form.hidden = true;
    if (this.title) this.title.hidden = true;
    this.successView.hidden = false;
  }

  close() {
    this.overlay.hidden = true;
    document.body.classList.remove('overflow-hidden');
    this.setStatus('', false);
    this.trigger.focus();
  }

  setStatus(message, isError) {
    this.status.textContent = message;
    this.status.classList.toggle('feedback-form__status--error', Boolean(isError));
  }

  async handleSubmit(event) {
    event.preventDefault();
    if (this.form.botcheck.value) return; // honeypot filled — drop silently

    const message = this.form.message.value.trim();
    if (!message) {
      this.setStatus('Please enter a message.', true);
      return;
    }

    this.submitButton.disabled = true;
    this.setStatus('Sending…', false);
    try {
      const response = await fetch(FEEDBACK_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          access_key: this.dataset.accessKey,
          subject: 'MomentDeck feedback (storefront)',
          from_name: 'MomentDeck Storefront',
          source: this.dataset.source,
          page_url: window.location.href,
          message: message,
          email: this.form.email.value.trim() || undefined,
        }),
      });
      const result = await response.json();
      if (!response.ok || !result.success) throw new Error(result.message || 'Submission failed');

      this.form.reset();
      this.showSuccess();
      setTimeout(() => this.close(), 2200);
    } catch (error) {
      console.error('[feedback] submission failed', error);
      this.setStatus('Could not send feedback. Please try again.', true);
    } finally {
      this.submitButton.disabled = false;
    }
  }
}

customElements.define('feedback-modal', FeedbackModal);
